// 파일을 Base64로 변환하는 함수 (확장자 포함)
export const toB64Obj = (
  file: File
): Promise<{ data: string; ext: string }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve({
          data: reader.result.split(",")[1],
          ext: file.name.split(".").pop()?.toLowerCase() || "",
        });
      } else {
        reject(new Error("파일 읽기에 실패했습니다."));
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
};

// Base64 문자열을 Data URI로 변환하는 함수
export const toDataUri = (
  x: string | { data: string; ext?: string }
): string => {
  const base = typeof x === "string" ? x : x.data;
  const ext = typeof x === "string" ? "png" : x.ext || "png";
  if (/^data:/i.test(base)) return base;
  const clean = base.replace(/\s+/g, "");
  const pad =
    clean.length % 4 ? clean + "=".repeat(4 - (clean.length % 4)) : clean;
  return `data:image/${ext};base64,${pad}`;
};
